import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @name CaptureEDEStatementsEnrollmentStatementsSettingsDD
 * @returns {React.Component}
 * @description A capture in the "EDE eStatement Enrollment" capture group.
 */
export default function CaptureEDEStatementsEnrollmentStatementsSettingsDD(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    useEffect(() => {
        document.querySelector("[data-point=edeStatementsMainNav_Account_Access] a").click()
    }, []);

    return <EDEStatementsPage />;
}